import React from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from '../components/Hero';

const Home = () => {
  const navigate = useNavigate();

  const handleEnter = () => {
    navigate('/works');
  };

  return (
    <div className="min-h-screen bg-off-black">
      <Hero onEnter={handleEnter} />
    </div>
  );
};

export default Home;
